import * as yup from "yup";
export const RL16SummarySetupSchema = yup.object().shape({
  rl16FiledOnPaper: yup.string().required("Filed On Paper is required!"),
  rl16FiledOnline: yup.string().required("Filed Online is required!"),
});
